import { RouteConfig, NavigationGuard } from 'vue-router';
import { AdminRoles } from '@/configs/role';
import { projectTypeList, ProjectTypes } from '@/configs/project';

const checkProjectType: NavigationGuard = (to, from, next) => {
  if (!to.params.projectType) {
    next({
      name: 'project-list',
      params: {
        projectType: ProjectTypes.LASTEST,
      },
    });
    return;
  }

  if (projectTypeList.includes(to.params.projectType as ProjectTypes)) {
    next();
    return;
  }

  next({
    name: 'project-list',
    params: {
      projectType: ProjectTypes.LASTEST,
    },
  });
};

const projectRoutes: RouteConfig = {
  path: 'project',
  component: () => import(/* webpackChunkName: 'dashboard.project' */ '@/pages/project/Index.vue'),
  redirect: {
    name: 'project-list',
    params: {
      projectType: ProjectTypes.LASTEST,
    },
  },
  children: [
    {
      path: ':projectType/list',
      name: 'project-list',
      component: () => import(/* webpackChunkName: 'dashboard.project' */ '@/pages/project/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
      beforeEnter: checkProjectType,
    },
    {
      path: `${ProjectTypes.LASTEST}/:projectId/edit`,
      name: 'project-edit-lastest',
      component: () => import(/* webpackChunkName: 'dashboard.project' */ '@/pages/project/Edit.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
        projectType: ProjectTypes.LASTEST,
      },
    },
    {
      path: `${ProjectTypes.OUTDATED}/:projectId/edit`,
      name: 'project-edit-outdated',
      component: () => import(/* webpackChunkName: 'dashboard.project' */ '@/pages/project/Edit.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
        projectType: ProjectTypes.OUTDATED,
      },
    },
  ],
};

export default projectRoutes;
